// extracted by mini-css-extract-plugin
export default {"checkCircleIcon":"TransferenceRequested_checkCircleIcon__Urcw1","button":"TransferenceRequested_button__ODwVT","cardMessage":"TransferenceRequested_cardMessage__Yzsql"};